import { useEffect, useContext, useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import _ from 'lodash';
import { Button } from '../StyledComponents';
import { ApparelContext } from '../context/FlowContext';

const SelectVariant = ({ nextStep }) => {
  const { activeApparelType, setActiveVariants } = useContext(ApparelContext);
  const [selectedVariants, setSelectedVariants] = useState([]);

  useEffect(() => {
    if (!activeApparelType || !activeApparelType?.variants?.length) {
      nextStep();
    }

    if (activeApparelType?.variants) {
      setSelectedVariants(activeApparelType.variants.map(() => []));
    }
  }, [activeApparelType, nextStep]);

  const handleSelectVariant = (variant, index) => {
    setSelectedVariants(prev => {
      const newVariants = [...prev];
      newVariants[index] = variant;
      return newVariants;
    });
  };

  const handleSubmitVariants = () => {
    setActiveVariants(activeApparelType?.name, selectedVariants);
    nextStep();
  };

  const isDisabled = selectedVariants.some(variant => variant.length === 0);

  if (!activeApparelType?.variants?.length) return null;

  return (
    <StyledFormStep
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
    >
      <h2>CUSTOM {_.replace(activeApparelType?.name, '_', ' ')}</h2>
      <p>SELECT YOUR STYLE(S)</p>
      <small>(One from each row)</small>

      <div className="rowContainer">
        {activeApparelType?.variants?.map((variantSet, setIndex) => (
          <div key={setIndex} className="row">
            <span>Choose: </span>
            {variantSet.map(variant => (
              <Button
                key={variant}
                onClick={() => handleSelectVariant(variant, setIndex)}
                className={
                  selectedVariants[setIndex] === variant ? 'selected' : ''
                }
              >
                {variant}
              </Button>
            ))}
          </div>
        ))}
      </div>

      <Button onClick={handleSubmitVariants} disabled={isDisabled}>
        Next
      </Button>
    </StyledFormStep>
  );
};

const StyledFormStep = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 20px 100px;

  @media (max-width: 991px) {
    padding: 20px 20px 100px;
  }

  h2 {
    margin-top: 0;
    margin-bottom: 0 !important;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  small {
    margin-bottom: 30px;
  }

  .rowContainer {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
    width: fit-content;
  }

  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    .span {
      width: 100px;
    }

    button {
      flex: 1;
      white-space: nowrap;
      opacity: 0.7;
      border: 2px solid transparent;

      &.selected {
        opacity: 1;
        border: 2px solid black;
      }
    }
  }
`;

export default SelectVariant;
